import Mock from '@/mocks/Mock'
import WeatherWarningHistory2, { WeatherWarningHistory2Attrs } from '@/models/WeatherWarningHistory2'
import { WeatherWarningHistoryParams } from '@/repositories/weather-warning-history-repository'

export default class WeatherWarningHistory2Mock extends Mock<WeatherWarningHistory2Attrs> {
  constructor() {
    super('weather_warning_history2')
  }

  get(params: WeatherWarningHistoryParams) {
    console.log(params)

    return new WeatherWarningHistory2(this.data)
  }
}
